// Sprite & langit mini untuk halaman pulau (Home): awan, burung, bintang, pohon, air, bangunan mini.

export function puff(ctx, x, y, r, a) {
  if (a <= 0.01) return;
  ctx.fillStyle = `rgba(255,255,255,${Math.min(1, a).toFixed(3)})`;
  ctx.beginPath();
  ctx.ellipse(x, y, r, r * 0.42, 0, 0, Math.PI * 2);
  ctx.ellipse(x - r * 0.55, y + r * 0.1, r * 0.6, r * 0.32, 0, 0, Math.PI * 2);
  ctx.ellipse(x + r * 0.5, y + r * 0.12, r * 0.65, r * 0.3, 0, 0, Math.PI * 2);
  ctx.fill();
}
export function hashN(n) {
  const x = Math.sin(n * 127.1 + 311.7) * 43758.5453;
  return x - Math.floor(x);
}
// Awan tipis yang melintas pelan di atas pulau (parameter deterministik per awan).
export const DRIFT_CLOUDS = Array.from({ length: 5 }, (_, i) => ({
  x0: ((i + 0.5) / 5 + hashN(i * 17.3) * 0.08) % 1, // fase awal tersebar merata di lintasan
  yf: 0.10 + 0.80 * ((i * 0.618) % 1),              // posisi vertikal tersebar (rasio emas)
  r: 0.6 + hashN(i * 31.7) * 0.8,                   // skala ukuran
  sp: 0.55 + hashN(i * 41.3) * 0.9,                 // kecepatan relatif
  ph: hashN(i * 53.9) * Math.PI * 2,                // fase ayunan
}));
export function drawDriftCloud(ctx, x, y, r, a, shadow = false) {
  if (a <= 0.01) return;
  ctx.fillStyle = shadow
    ? `rgba(12,40,16,${Math.min(1, a).toFixed(3)})`
    : `rgba(255,255,255,${Math.min(1, a).toFixed(3)})`;
  ctx.beginPath();
  ctx.ellipse(x, y, r, r * 0.30, 0, 0, Math.PI * 2);
  ctx.ellipse(x - r * 0.62, y + r * 0.06, r * 0.55, r * 0.22, 0, 0, Math.PI * 2);
  ctx.ellipse(x + r * 0.58, y + r * 0.08, r * 0.60, r * 0.20, 0, 0, Math.PI * 2);
  ctx.ellipse(x + r * 0.15, y - r * 0.12, r * 0.45, r * 0.26, 0, 0, Math.PI * 2);
  ctx.fill();
}
// Sekawanan burung kecil: formasi V, melintas tiap FLOCK_CYCLE detik (terbang FLOCK_FLY detik),
// arah berganti tiap lintasan, memudar saat malam.
const FLOCK_CYCLE = 45, FLOCK_FLY = 16;
function drawBird(ctx, x, y, s, flap, a) {
  const wy = flap * s * 0.6; // ujung sayap naik/turun saat mengepak
  ctx.strokeStyle = `rgba(40,48,60,${a.toFixed(3)})`;
  ctx.lineWidth = Math.max(1, s * 0.22);
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.moveTo(x - s, y - wy);
  ctx.quadraticCurveTo(x - s * 0.5, y + wy * 0.3, x, y);
  ctx.quadraticCurveTo(x + s * 0.5, y + wy * 0.3, x + s, y - wy);
  ctx.stroke();
}
export function drawFlock(ctx, t, W, isTop, isBot, compact, a) {
  const cyc = Math.floor(t / FLOCK_CYCLE), tc = t - cyc * FLOCK_CYCLE;
  if (tc > FLOCK_FLY || a <= 0.02) return;
  const p = tc / FLOCK_FLY;
  const dir = cyc % 2 ? -1 : 1; // ganjil: kanan→kiri, genap: kiri→kanan
  const s = compact ? 3.6 : 5.5, gap = s * 2.8, margin = gap * 6;
  const lx = dir > 0 ? -margin + (W + margin * 2) * p : W + margin - (W + margin * 2) * p;
  const ly = isTop + (isBot - isTop) * (0.12 + hashN(cyc * 7.7) * 0.43) - Math.sin(p * Math.PI) * (isBot - isTop) * 0.06;
  const n = compact ? 6 : 9;
  for (let k = 0; k < n; k++) {
    const row = Math.ceil(k / 2), side = k % 2 ? -1 : 1;
    const bx = lx - dir * row * gap + (hashN(k * 3.3) - 0.5) * gap * 0.4;
    const by = ly + side * row * gap * 0.55 + Math.sin(t * 1.3 + k) * 1.5;
    drawBird(ctx, bx, by, s, Math.sin(t * 7 + hashN(k * 9.1) * Math.PI * 2), a);
  }
}
const SKY_KEYS = [
  [0, [10, 14, 36], [26, 32, 60], 1],
  [4.5, [10, 14, 36], [26, 32, 60], 1],
  [6, [96, 110, 152], [242, 188, 142], 0.55],
  [7.5, [191, 227, 240], [232, 244, 224], 0],
  [16.5, [176, 216, 240], [232, 244, 224], 0],
  [18, [88, 100, 164], [242, 158, 102], 0.45],
  [19.5, [10, 14, 36], [26, 32, 60], 1],
  [24, [10, 14, 36], [26, 32, 60], 1],
];
function lerp3(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
export function skyAt(h) {
  for (let i = 0; i < SKY_KEYS.length - 1; i++) {
    const A = SKY_KEYS[i], B = SKY_KEYS[i + 1];
    if (h >= A[0] && h <= B[0]) {
      const t = (h - A[0]) / (B[0] - A[0]);
      return { top: lerp3(A[1], B[1], t), bot: lerp3(A[2], B[2], t), dark: A[3] + (B[3] - A[3]) * t };
    }
  }
  return { top: SKY_KEYS[0][1], bot: SKY_KEYS[0][2], dark: SKY_KEYS[0][3] };
}
export function rgb(c) { return `rgb(${c[0] | 0},${c[1] | 0},${c[2] | 0})`; }
export const HOME_STARS = Array.from({ length: 90 }, (_, i) => ({
  x: hashN(i * 3.17), y: hashN(i * 7.71) * 0.62,
  r: 0.5 + hashN(i * 13.3) * 1.2, tw: 0.6 + hashN(i * 29.9) * 2.2,
}));
export function drawTree(ctx, x, y, s) {
  ctx.strokeStyle = "#7a5230";
  ctx.lineWidth = Math.max(1, s * 0.20);
  ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x, y - s * 0.62); ctx.stroke();
  ctx.fillStyle = "#4c8f43";
  ctx.beginPath(); ctx.arc(x, y - s * 0.92, s * 0.58, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "#69b457";
  ctx.beginPath(); ctx.arc(x - s * 0.20, y - s * 1.06, s * 0.34, 0, Math.PI * 2); ctx.fill();
}
export function drawWater(ctx, x, y, s) {
  ctx.fillStyle = "rgba(56,150,215,0.85)";
  ctx.beginPath(); ctx.ellipse(x, y, s * 0.95, s * 0.45, -0.2, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = "rgba(255,255,255,0.55)";
  ctx.lineWidth = Math.max(0.7, s * 0.10);
  ctx.beginPath(); ctx.ellipse(x - s * 0.1, y - s * 0.05, s * 0.55, s * 0.22, -0.2, 0, Math.PI); ctx.stroke();
}
export function drawMiniBuilding(ctx, x, y, s, seed) {
  const roofs = [[210, 74, 64], [74, 132, 201], [232, 164, 32], [150, 110, 72]];
  const roof = roofs[Math.floor(hashN(seed) * roofs.length) % roofs.length];
  const h = s * (1.15 + hashN(seed + 3) * 0.95);
  ctx.fillStyle = "rgba(0,0,0,0.14)";
  ctx.beginPath(); ctx.ellipse(x, y + s * 0.18, s * 0.74, s * 0.26, 0, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "#e7e5dc";
  ctx.beginPath();
  ctx.moveTo(x - s * 0.5, y); ctx.lineTo(x, y + s * 0.28); ctx.lineTo(x, y + s * 0.28 - h); ctx.lineTo(x - s * 0.5, y - h);
  ctx.closePath(); ctx.fill();
  ctx.fillStyle = "#fbfaf5";
  ctx.beginPath();
  ctx.moveTo(x, y + s * 0.28); ctx.lineTo(x + s * 0.5, y); ctx.lineTo(x + s * 0.5, y - h); ctx.lineTo(x, y + s * 0.28 - h);
  ctx.closePath(); ctx.fill();
  ctx.fillStyle = `rgba(${roof[0]},${roof[1]},${roof[2]},1)`;
  ctx.beginPath();
  ctx.moveTo(x - s * 0.60, y - h); ctx.lineTo(x, y - h - s * 0.32); ctx.lineTo(x + s * 0.60, y - h); ctx.lineTo(x, y - h + s * 0.32);
  ctx.closePath(); ctx.fill();
  ctx.strokeStyle = "rgba(30,41,59,0.18)";
  ctx.lineWidth = Math.max(0.6, s * 0.05);
  ctx.stroke();
}
